import {
  CanalDisponivelDTO,
  DefinirRegraDTO,
  MatrizRegrasDTO,
} from "@/types/notificacao-regra.type";
import { httpClient } from "./httpClient";

/**
 * Freio global de envio (chave geral por template × canal).
 * Ver `docs/notificacoes-regras-envio.md`.
 */
class NotificacaoRegraService {
  private readonly adminPath = "api/v1/admin/notificacoes/regras";

  public async getMatriz(): Promise<MatrizRegrasDTO> {
    return httpClient.get<MatrizRegrasDTO>(this.adminPath);
  }

  public async definir(dto: DefinirRegraDTO): Promise<void> {
    return httpClient.put<void>(this.adminPath, dto);
  }

  /** Qualquer usuário logado — usado pela tela de preferências. */
  public async getCanaisDisponiveis(): Promise<CanalDisponivelDTO[]> {
    return httpClient.get<CanalDisponivelDTO[]>("api/v1/notificacoes/canais-disponiveis");
  }
}

export const notificacaoRegraService = new NotificacaoRegraService();
